import React from 'react';

export type IconName =
    | 'airplane'
    | 'alex_ai_bot'
    | 'auto_fix_ico_g'
    | 'concept_ico_f'
    | 'product_ico_f'
    | 'retail_ico_f'
    | 'revenue_ico_f'
    | 'zoom_ico'
    | 'close_ico';

interface AppIconProps {
    name: IconName;
    size?: number;
    className?: string;
    alt?: string;
}


const AppIcon: React.FC<AppIconProps> = ({
                                             name,
                                             size = 16,
                                             className = '',
                                             alt = ''
                                         }) => {
    const iconPath = `/images/icons/${name}.svg`;

    const accessibilityText = alt || `${name} icon`;
    return (
        <img
            src={iconPath}
            alt={accessibilityText}
            width={size}
            height={size}
            className={className}
        />
    );
};

export default AppIcon;